import cn from "classnames";
import React from "react";
import { Badge } from "reactstrap";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  formattedTotal: string;
  formattedMonthly: string;
  showMonthly: boolean;
  onToggleMonthly: () => void;
  compact?: boolean;
}

export const ExpectedResultBadge = ({
  formattedTotal,
  formattedMonthly,
  showMonthly,
  onToggleMonthly,
  compact = false,
}: Props) => {
  const intl = useIntl();

  return (
    <div
      className={cn("crm-expected-result align-items-center", {
        "d-none d-md-flex": !compact,
        "d-flex d-md-none": compact,
        "mr-2": !compact,
        "mr-1": compact,
      })}
    >
      <Badge
        className={cn("text-white text-wrap", {
          "py-2 px-3": !compact,
          "py-1 px-2": compact,
        })}
        color="success"
        style={compact ? { fontSize: "0.7rem", maxWidth: "42vw" } : undefined}
      >
        {intl.formatMessage(
          { id: "app.crmBusiness.totalProbability" },
          { probability: formattedTotal }
        )}
        {showMonthly && (
          <span className="crm-expected-result__monthly">
            {intl.formatMessage(
              { id: "app.crmBusiness.totalProbabilityMonthly" },
              { probability: formattedMonthly }
            )}
          </span>
        )}
      </Badge>
      <button
        type="button"
        className={cn("crm-expected-result__toggle", {
          "crm-expected-result__toggle--active": showMonthly,
        })}
        onClick={onToggleMonthly}
        title={intl.formatMessage({
          id: showMonthly
            ? "app.crmBusiness.hideMonthlyExpected"
            : "app.crmBusiness.showMonthlyExpected",
        })}
        aria-label={intl.formatMessage({
          id: showMonthly
            ? "app.crmBusiness.hideMonthlyExpected"
            : "app.crmBusiness.showMonthlyExpected",
        })}
        aria-pressed={showMonthly}
      >
        <FontAwesomeIcon icon={["far", "calendar-alt"]} />
      </button>
    </div>
  );
};
